import React, { Component } from 'react';
import { connect } from 'react-redux';
import _, { isEmpty, get, uniqBy } from 'lodash';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import routes from '../../../../routes';

import Input from '../../../../components/FormElements/Input';
import Select from '../../../../components/FormElements/SelectNew';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import MultiSelect from '../../../../components/FormElements/MultiSelect';
import BinarySelect from '../../../../components/BinarySelect';


import { formFields, roleTenantListFields, confirmationMessage, successfullyMessage, countryCodeConstant, countryLengthConstant } from './constant';
import { handleFieldError, initializeForm, handleError } from '../../../../utils/form-validation';
import { addAdminUserAction, getAccountsListAction, getTenantAction, getAdminUserListAction, getAdminRolesListAction, getUserListByEmailAction, getAdminUserSingleListAction, configAttributeAction } from '../../../../actions';
import { sortArray, removeSpaces, getIndividualData, getCombinedData, isApiCallSuccess, isTenantDemoAdvertiser, isTenantPlatformManager } from '../../../../selectors';
import ToastModal from "../../../../components/ToastModal";
import { message } from 'antd';
import { infoMessages } from '../../../../constants/demo/constant';

const Card = asyncRoute(() => import('../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../components/BreadCrumb'));
const Modal = asyncRoute(() => import('../../../../components/Modal'));

class AddUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {},
      touched: {},
      errors: {},
      submited: false,
      confirmationOpen: false,
      confirmationInfo: '',
      confirmationRemove: false,
      removeRoleIndex: '',
      oldList: [],
      enableToast: false,
      toastStatus: "",
      toastMsg: "",
      confirmationMsg: "",
      isActiveIndex: null,
      phonenumberLenghtValidationPacket: [],
      formFields: formFields,
      idExists: null,
      isRoleChanged: true,
      accountListData: [],
      tenantListData: [],
      tenantTypeList: []
    };
  }

  componentWillMount() {
    try {
      const { match: { params: { id } }, tenantId } = this.props;
      const { form } = this.state;
      let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
      const localStorageTenantData = JSON.parse(localStorage.getItem("PreSignInData"))

      const logedInTenantDeatail = localStorageTenantData && localStorageTenantData.responseList && localStorageTenantData.responseList.find((data) => data.tenantId == tenantId)
      if (isEmpty(isAuthenticated)) {
        const { history } = this.this.props;
        history.push(routes.preSignIn);
      }
      const PhoneNumberMergedArray = countryCodeConstant.map((data) => {
        const matchingItem2 = countryLengthConstant.find((data2) => data2.country === data.name);
        if (matchingItem2) {
          // If a match is found, merge the data
          return { ...data, ...matchingItem2 };

        } else {
          // If no match is found, return the original item from array1
          return data;
        }
      })
      const findLengthPhoneNumber = PhoneNumberMergedArray && PhoneNumberMergedArray.find((ele) => ele.name == logedInTenantDeatail.contact.country && logedInTenantDeatail.contact.country)
      if (findLengthPhoneNumber) {
        this.setState({ phonenumberLenghtValidationPacket: findLengthPhoneNumber })
        this.setState((prevState) => ({
          formFields: {
            ...prevState.formFields,
            contact: {
              ...prevState.formFields.contact,
              minLength: findLengthPhoneNumber.phoneNumberLengthByCountry_phLength, maxLength: findLengthPhoneNumber.phoneNumberLengthByCountry_phLength,
              minLengthMessage: `Minimum and Maximum  ${findLengthPhoneNumber.phoneNumberLengthByCountry_phLength} digit allowed.`, maxLengthMessage: `Minimum and Maximum  ${findLengthPhoneNumber.phoneNumberLengthByCountry_phLength} digit allowed.` // Assuming you have a 'value' field in your formFields
            },
          },
        }));
      }
      this.getTenantAction();
      this.formInitialize();
      this.getTenantTypes();
    } catch (error) {
      console.log(error);
    }
  }

  componentDidMount() {
    this.updateIsDemoAdvertiser();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tenantId !== this.props.tenantId) {
      this.updateIsDemoAdvertiser();
    }
  }

  updateIsDemoAdvertiser = () => {
    const { tenantId } = this.props;
    const isDemoAdvertiser = isTenantDemoAdvertiser(tenantId);
    this.setState({ isDemoAdvertiser });
  };

  async getTenantList() {
    const { getTenantAction, tenantId, authToken, userId } = this.props;
    const { responseCode: { msg = '', status = '' }, responseList } = await getTenantAction({ tenantId, authToken, userId });
    if (isApiCallSuccess(status)) {
      this.setState({ tenantListData: responseList });
    }
  }

  async getAccountList() {
    const { getAccountsListAction, tenantId, authToken, userId } = this.props;
    const { responseCode: { msg = '', status = '' }, responseList } = await getAccountsListAction(tenantId, authToken, userId);
    if (isApiCallSuccess(status)) {
      this.setState({ accountListData: responseList });
    }
  }

  async getTenantAction() {
    const { match: { params: { id } }, getAdminRolesListAction, getTenantAction, getAccountsListAction, tenantId, authToken, userId } = this.props;
    const addParams = "all"
    await getAdminRolesListAction({ tenantId, authToken, userId, addParams });
    await this.getAccountList();
    await this.getTenantList();
    if (id) {
      this.editId(id);
    }
  }

  async getTenantTypes() {

    const { configAttributeAction, userId, tenantId, authToken } = this.props;
    let type = 'TENANT_TYPE';
    let tenantTypeList = await configAttributeAction({ tenantId, authToken, userId, type });

    let list = [];
    if (this.state.isDemoAdvertiser) {
      list = tenantTypeList.responseList.filter(tenantType => tenantType.value != "Platform Manager" && tenantType.value == "Demo Advertiser");
    } else if (isTenantPlatformManager(tenantId)) {
      list = tenantTypeList.responseList.filter(tenantType => tenantType.value == "Advertiser" || tenantType.value == "DSP/Ad network" || tenantType.value == "Demo Advertiser");
    } else {
      list = tenantTypeList.responseList.filter(tenantType => tenantType.value != "Platform Manager" && tenantType.value == "Advertiser" || tenantType.value == "DSP/Ad network");
    }

    this.setState({ tenantTypeList: list });
  }

  async formInitialize() {
    const { formFields } = this.state
    const { form, errors } = initializeForm(formFields);
    form.roleTenantList = [{
      roleId: '',
      tenantsList: [],
      isActive: 1,
      errors: {}
    }];
    this.setState({ form, errors });

  }

  editId = async (id) => {
    const { getAdminUserSingleListAction, tenantId, authToken, userId } = this.props;
    let respone = await getAdminUserSingleListAction({ tenantId, authToken, userId, id });
    if (respone && respone.responseCode && respone.responseCode.status === "Success" && respone.responseList && respone.responseList.length) {
      let userObj = respone.responseList.find((a) => a.id == id);
      if (userObj) {
        let form = {};
        // console.log(userObj);
        form.id = userObj.id;
        form.name = userObj.name;
        form.email = userObj.email;
        form.contact = userObj.contact;
        form.isActive = userObj.isActive;
        form.isRecActive = userObj.isRecActive
        form.roleTenantList = getCombinedData(userObj.roleTenantList);
        // form.roleTenantList = getCombinedData(userObj.roleTenantList).filter(role => role.isRecActive != 0);
        form.roleTenantList = form.roleTenantList.map(item => {
          item.errors = {};
          item.tenantType = item.roleTenantType;
          return item;
        });
        this.setState({ form, oldList: userObj.roleTenantList, userObj }, () => {
          this.generatePayload(form, id, userObj.isRecActive)
        });
      }
    }
  };

  handleChange = (e) => {
    const { form } = this.state;
    let { value, name, min, max } = e.target;

    if (min && max) {
      value = Math.max(Number(min), Math.min(Number(max), Number(value)));
    }

    form[name] = value;

    this.setState({ form });
  };

  handleTouch = (e) => {
    let { touched, form, errors, formFields } = this.state;
    let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
    errors[e.target.name] = error;
    touched[e.target.name] = true;
    this.setState({ touched, errors });
  };

  toggleModal = (confirmation) => {
    const { confirmationOpen } = this.state;
    this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
  };

  confirmationCallBack = (success, info) => {
    const { confirmationOpen } = this.state;
    if (success && info.action.type === 'Confirmation') {
      this.submitForm();
    } else if (info.action.type === 'alert') {
      this.setState({ confirmationOpen: !confirmationOpen }, () => {
        const { history } = this.props;
        history.push(`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}`);
      });
      return;
    }
    this.setState({ confirmationOpen: false });
  };


  async submitForm() {
    try {
      const { match: { params: { id } }, addAdminUserAction, tenantId, authToken, userId } = this.props;

      const { form, idExists } = this.state;
      let addParams = 'auto';

      // if (id) {
      //   addParams = id;
      // }

      let idForUser = idExists ? idExists.id : id ? id : null;
      let statusOfUser = null;

      if (idExists) {
        statusOfUser = idExists.isRecActive
      }
      else if (id) {
        statusOfUser = form.isRecActive
      }

      let payload = this.generatePayload(form, idForUser, statusOfUser);


      const uniqueIds = [];
      const uniqueTenant = payload.roleTenantList.filter(element => {
        const isDuplicate = uniqueIds.includes(element.tenantId);
        if (!isDuplicate) {
          uniqueIds.push(element.tenantId);
          return true;
        }
        return false;
      });
      if (uniqueTenant.length == payload.roleTenantList.length) {
        // console.log(payload, 'payload');
        // return;

        const { responseCode: { msg = '', status = '' } } = await (addAdminUserAction({ tenantId, authToken, userId, payload, addParams }) || '');

        //   if (status === 'Success') {
        //     this.setState({ confirmationOpen: false }, () => {
        //       this.toggleModal(successfullyMessage);
        //     });
        //     return;
        //   } else {
        //     const info = { action: { confirmationMessage: msg, type: 'error' } };
        //     this.toggleModal(info);
        //   }
        //   this.formInitialize();
        // } else {
        //   const errormsg = { action: { confirmationMessage: "Tenant must have single role", type: 'error' } };
        //   this.setState({ confirmationOpen: false }, () => {
        //     this.toggleModal(errormsg);
        //   });
        this.setState({ idExists: null });
        if (status) {
          this.toast(status, msg);
        }
      } else {
        this.setState({ enableToast: true, toastStatus: 'Fail', toastMsg: "Can not assign multiple roles to a single tenant!" });
      }
    }
    catch (err) {
      this.setState({ idExists: null });
    }
  }

  generatePayload(form, id, statusOfUser) {
    const { oldList, isActiveIndex } = this.state;
    const { rolesList, tenantListAll } = this.props;
    // console.log(rolesList,"roleList")
    let payload = {}, roleName = '', tenantName = '';
    payload.id = id ? id : undefined;
    payload.name = removeSpaces(form.name);
    payload.contact = form.contact;
    payload.email = form.email.toLowerCase();
    payload.isActive = 1;
    payload.uID = form.email;
    if (statusOfUser != null) {
      payload.isRecActive = statusOfUser;
    }
    // payload.isActive = id ? form.isActive === 1 ? 0: 1 : 1;
    // console.log(form,"formMAinFile")
    let roleTenantList = getIndividualData(_.cloneDeep(form.roleTenantList)).map(item => {
      // console.log(item,"item")
      const role = rolesList.find(role => role.roleName == item.roleId);
      // console.log(role,"role")
      if (role) {
        roleName = role.roleName;
      }
      const tenant = tenantListAll.find(tenant => tenant.tenantId == item.tenantId);
      if (tenant) {
        tenantName = tenant.tenantName;
      }
      return { ...item, roleName, tenantName }
    })
    roleTenantList.map(item => item.tenantId = parseInt(item.tenantId))
    payload.roleTenantList = roleTenantList;
    // console.log(payload.roleTenantList,"payload.roleTenantList", roleTenantList)
    const removedList = [];
    if (oldList.length > 0) {
      for (let i = 0; i < oldList.length; i++) {
        const flag = true;
        for (let j = 0; j < roleTenantList.length; j++) {
          if (oldList[i].tenantId === roleTenantList[j].tenantId) {
            flag = false;
            removedList.push(roleTenantList[j]);
          }
          else {
            removedList.push(roleTenantList[j]);
          }
        }
        if (flag) {
          // oldList[i].isActive = 0;
          oldList[i].isRecActive = 0;
          removedList.push(oldList[i])
        }
      }
      let jsonObject = removedList.map(JSON.stringify);
      let uniqueSet = new Set(jsonObject);
      let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
      payload.roleTenantList = uniqueArray
    }
    if (id) {
      let areAllUsersInActive = payload.roleTenantList.every(role => role['isRecActive'] == 0);
      let areAllUsersActive = payload.roleTenantList.every(role => role['isRecActive'] == 1);
      payload.isRecActive = areAllUsersInActive ? 0 : areAllUsersActive ? 1 : form.isRecActive;
    }
    return payload;
  }

  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.state.isDemoAdvertiser) {
      message.info(infoMessages.userUpdate);
      return;
    }

    try {
      const { match: { params: { id } }, getUserListByEmailAction, tenantId, authToken, userId } = this.props;
      const { form, formFields } = this.state;
      let validFlagMulit = this.handleRoleTenantError();
      let { errors, valid } = handleError(form, formFields);

      // console.log(form, 'formData');

      if (valid && validFlagMulit) {

        let isError = false;

        const params = {
          list: "search",
          srch: form.email
        }

        const { responseCode: { status = "" }, responseList = [] } = await getUserListByEmailAction({ tenantId, authToken, userId, params })

        if (isApiCallSuccess(status)) {
          if (responseList.length > 0) {
            const userData = responseList.find((user) => user.email == form.email);
            if (userData) {
              if (form.email == userData.email && id && userData.id != id) {
                isError = true;
                this.setState({ enableToast: true, toastStatus: 'Fail', toastMsg: "Email already exists" });
              }
              else {
                this.setState({ idExists: userData });
              }
            }
          }
        }
        if (!isError) {
          this.setState({ enableToast: true, toastStatus: 'confirmation', confirmationMsg: "Kindly let us know if you'd like to save your changes." });
        }
      } else {
        this.setState({ errors: errors, submited: true });
      }
    }
    catch (err) {
      this.setState({ idExists: null })
    }
  };

  addUserTenantRole = () => {
    const { form: { roleTenantList }, form } = this.state;
    roleTenantList.push({
      srNo: 1,
      roleId: '',
      tenantsList: [],
      isRecActive: 1,
      isActive: 1,
      errors: {}
    });
    this.setState({ form });
  };

  removeUserTenantRole = index => {
    const { form } = this.state;
    form.roleTenantList.splice(index, 1);
    this.setState({ form });
  };

  handleRoleTenantChange = (e, index, rolesList) => {
    let { form } = this.state;

    if ((e.target.name).includes('isRecActive')) {
      // form.roleTenantList[index].isActive = e.target.value;
      form.roleTenantList[index].isRecActive = e.target.value;
      this.setState({ isActiveIndex: form.roleTenantList[index].isRecActive });
      form.roleTenantList[index].errors.isRecActive = {};
    }
    else if (e.target.name == 'roleId') {
      const roleListData = rolesList.find(el => el.value == e.target.value || el.id == e.target.value)
      form.roleTenantList[index][e.target.name] = roleListData.id;
      // form.roleTenantList[index][e.target.name] = roleListData.value;
    }
    else {
      form.roleTenantList[index][e.target.name] = e.target.value;
      form.roleTenantList[index].errors[e.target.name] = {};
    }

    // console.log("form", form);
    this.setState({ form });
  };

  // handleRoleTenantError = () => {
  //   const { form } = this.state;
  //   let check = false;

  //   form.roleTenantList.forEach((item) => {
  //     if (item.roleId == '') {
  //       item.errors.roleId = { required: true };
  //       check = true;
  //     } else {
  //       item.errors.roleId = {};
  //     }
  //     if (item.tenantsList.length === 0) {
  //       item.errors.tenantsList = { required: true };
  //       check = true;
  //     } else {
  //       item.errors.tenantsList = {};
  //     }
  //     if (!item.isActive) {
  //       item.errors.isActive = { required: true };
  //       check = true;
  //     } else {
  //       item.errors.isActive = {};
  //     }
  //   });
  //   this.setState({ form });
  //   return !check;
  // };

  handleRoleTenantError = () => {
    let { form } = this.state;
    let check = true;

    let roleTenantList = form.roleTenantList.map((item) => {
      const { errors, valid } = handleError(item, roleTenantListFields);
      item.errors = errors;
      if (!check || !valid) {
        check = false;
      } else if (check && valid) {
        check = true;
      }
      return item;
    });
    form.roleTenantList = roleTenantList;
    this.setState({ form });
    return check;
  };

  getRolesTypeFromTenant = (rolesList, tenantType) => {
    const { pathname } = this.props.location;
    let list = [];
    if (tenantType) {
      if (pathname.includes("add-user")) {
        list = rolesList.filter(item => item.tenantType == tenantType && item.roleType != 3);
      } else if (pathname.includes("edit-user")) {
        list = rolesList.filter(item => item.tenantType == tenantType);
      }
      return list;
    } else {
      return list;
    }
  };

  getTenantList = (tenantList, tenantType) => {
    let list = [];
    if (tenantType) {
      list = tenantList.filter(item => item.tenantType == tenantType);
      return list;
    } else {
      return list;
    }
  };

  isTenantDefaultRoleChecked = (item, rolesList) => {
    const role = rolesList.filter((role, inx) => item.roleId === role.id)[0];
    if (role && role.roleType == 3) return true;
    else return false
  }


  renderUserTenantRoleList = (item, index, rolesList, tenantList) => {
    let { form, submited, tenantTypeList } = this.state;
    let { pathname } = this.props.location;

    const isDisabled = this.isTenantDefaultRoleChecked(item, rolesList);
    rolesList = !isDisabled ? rolesList.filter((role, inx) => role.roleType !== 3) : rolesList

    if (pathname.includes("edit-user")) {
      if (isDisabled && item.tenantsList && Array.isArray(item.tenantsList) && item.tenantsList.length == 0) {
        return
      }
    }


    return (
      <div className={`row ${index > 0 ? 'role-card pb-2 px-2' : 'pb-2 px-2'}`} key={index}>
        <div className='col-lg-2'>
          <Select
            onChange={(e) => this.handleRoleTenantChange(e, index)}
            onBlur={this.handleTouch}
            value={item.tenantType}
            setting={roleTenantListFields[roleTenantListFields.tenantType.key]}
            error={item.errors[roleTenantListFields.tenantType.key]}
            submited={submited}
            options={tenantTypeList}
            disabled={isDisabled}
          />
        </div>

        <div className='col-lg-3'>
          {/* {
            id ?

              <div className='custom-test-select new'>
                <label for="cars" className='mt-2'>Role <span className='text-danger'>*</span></label>
                <select name="roleId" onChange={(e) => this.handleRoleTenantChange(e, index, rolesList)} className='mt-2'>
                  <option value="Select">Select</option>
                  {
                    rolesList.map(option => option.id == item.roleId ?
                      <option value={option.id} selected>{option.value}</option> : <option value={option.id}>{option.value}</option>
                    )
                  }
                </select>
              </div>
              :
              <Select
                onChange={(e) => this.handleRoleTenantChange(e, index, rolesList)}
                onBlur={this.handleTouch}
                value={item.roleId != "" ? item.roleId : null}
                setting={roleTenantListFields[roleTenantListFields.roleId.key]}
                error={item.errors[roleTenantListFields.roleId.key]}
                submited={submited}
                options={rolesList}
              />
          } */}

          <Select
            onChange={(e) => this.handleRoleTenantChange(e, index, rolesList)}
            onBlur={this.handleTouch}
            value={item.roleId != "" ? item.roleId : null}
            setting={roleTenantListFields[roleTenantListFields.roleId.key]}
            error={item.errors[roleTenantListFields.roleId.key]}
            submited={submited}
            // options={rolesList}
            options={this.getRolesTypeFromTenant(rolesList, item.tenantType)}
            disabled={isDisabled}
          />

        </div>

        <div className='col-lg-3'>
          <MultiSelect
            onChange={(e) => this.handleRoleTenantChange(e, index)}
            onBlur={this.handleTouch}
            value={item.tenantsList}
            setting={roleTenantListFields[roleTenantListFields.tenantsList.key]}
            error={item.errors[roleTenantListFields.tenantsList.key]}
            submited={submited}
            allowClear={false}
            options={this.getTenantList(tenantList, item.tenantType)}
            disabled={isDisabled}
          />
        </div>
        <div className='col-lg-3'>
          <BinarySelect
            onChange={(e) => this.handleRoleTenantChange(e, index)}
            onBlur={this.handleTouch}
            setting={{ ...roleTenantListFields[roleTenantListFields.isRecActive.key], key: roleTenantListFields.isRecActive.key + index }}
            options={sortArray((roleTenantListFields[roleTenantListFields.isRecActive.key]).options)}
            value={item.isRecActive}
            error={item.errors[roleTenantListFields.isRecActive.key]}
            submited={submited}
            disabled={isDisabled}
          />
        </div>
        <div className="col-lg-1 d-flex form-group justify-content-center">
          {form.roleTenantList.length > 1 &&
            <button
              disabled={isDisabled}
              onClick={() => this.removeUserTenantRole(index)} className="btn text-primary mt-3">
              <i style={{ fontSize: 18 }} className='ti ti-minus' />
              <span style={{ fontSize: 14 }}>Remove</span>
            </button>
            // <button type='button' onClick={() => this.removeUserTenantRole(index)} className='btn p-0' style={{ backgroundColor: "transparent" }}>
            //   <i className='mdi mdi-close-circle' style={{ fontSize: '30px', color: "#f70000" }}></i>
            // </button>
          }
        </div>
      </div>
    );
  };

  reset = () => {
    this.formInitialize();
  };

  toast = (status, msg) => {
    this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
    return;
  }

  confirmationCallbackModel = (id) => {
    this.setState({ enableToast: false }, () => {
      this.submitForm();
    });
  }

  handleToastStatus = (status) => {
    this.setState({ enableToast: status });
  }

  render() {
    const { confirmationOpen, confirmationInfo, submited, errors, touched, form, enableToast,
      toastMsg,
      toastStatus,
      formFields,
      confirmationMsg, phonenumberLenghtValidationPacket, accountListData, tenantListData } = this.state;
    const { rolesList: roles, accountListAll, tenantListAll, match: { params: { id } }, tenantType } = this.props;
    const isActiveRoles = roles.filter((data) => data.isActive == true)
    let rolesList = []
    let tenantList = []
    if (tenantType == "Platform Manager") {
      let optionsData = tenantListAll;
      if (optionsData && optionsData.length == 0) {
        optionsData = tenantListData;
      }
      tenantList = _.map(optionsData, (item) => ({ id: item.tenantId, text: item.tenantName, tenantType: item.tenantTypeId }));
      rolesList = (uniqBy(isActiveRoles, "roleId")).filter((a) => (a.roleType != 1)).map((a) => ({ id: a.roleId, value: a.roleName, tenantType: a.tenantType, roleType: a.roleType }));
      // rolesList = (uniqBy(isActiveRoles, "roleId")).filter((a) => (a.roleType != 1)).map((a) => ({ id: a.roleId, value: a.roleName, tenantType: a.tenantType }));
      // rolesList = _.map(roles, (item) => ({ id: item.roleId, value: item.roleName }));
    }
    else {
      let optionsData = accountListAll;
      if (optionsData && optionsData.length == 0) {
        optionsData = accountListData;
      }
      tenantList = _.map(optionsData, (item) => ({ id: item.accTenantId, text: item.accountName, tenantType: item.tenantType }));
      rolesList = (uniqBy(isActiveRoles, "roleId")).filter((a) => (a.roleType != 1)).map((a) => ({ id: a.roleId, value: a.roleName, tenantType: a.tenantType, roleType: a.roleType }));
      // rolesList = (uniqBy(isActiveRoles, "roleId")).filter((a) => (a.roleType == 2 || a.roleType == 3)).map((a) => ({ id: a.roleId, value: a.roleName, tenantType: a.tenantType }));
      //  const rolesList = _.map(roles, (item) => ({ id: item.roleId, value: item.roleName }));
      // const tenantList = _.map(tenantListAll, (item) => ({ id: item.tenantId, text: item.tenantName }));
    }
    return (
      <>
        {confirmationOpen && (<ModalConfirmation
          open={confirmationOpen}
          onClose={this.toggleModal}
          confirmationInfo={confirmationInfo}
          handelConfirmationMessage={this.confirmationCallBack}
        />)}

        {
          enableToast && <ToastModal
            enableToast={enableToast}
            status={toastStatus}
            msg={toastMsg}
            path={routes.containers.admin + '/' + routes.admin.user.name}
            idProps={this.props}
            handleConfirmation={this.confirmationCallbackModel}
            handleToastStatus={this.handleToastStatus}
            confirmationMsg={confirmationMsg}
            outSideClickEnable={false}
          />
        }

        <div className="main-panel ion form__style">
          <div className="content-wrapper">
            <BreadCrumb />
            <div className="row justify-content-center mt-3">
              <div className="col-md-12 grid-margin">
                {/* <Card>
                  <div className="float-right">
                    <Link
                      to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}`}                    >
                      <button
                        type="button"
                        className="btn btn-primary">
                        <i className="mdi mdi-keyboard-backspace"></i>Back to User
                      </button>
                    </Link>
                  </div>
                </Card> */}
                <Card>
                  <div className='d-flex justify-content-end'>
                    <Link
                      to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}`}
                      className='text-white text-decoration-none btn btn-primary ml-4'
                      style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }}
                    >
                      <i className="ti ti-arrow-narrow-left ti-sm"></i>
                      Back to User
                    </Link>
                  </div>

                  <div className="col-md-12 d-flex">
                    <div className="col-md-6 pl-0">
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.name.key]}
                        setting={formFields[formFields.name.key]}
                        error={errors[formFields.name.key]}
                        submited={submited}
                        touched={touched[formFields.name.key]}
                      />
                    </div>

                    <div className="col-md-6">
                      <Input
                        onChange={this.handleChange}
                        onBlur={this.handleTouch}
                        value={form[formFields.email.key]}
                        setting={formFields[formFields.email.key]}
                        error={errors[formFields.email.key]}
                        submited={submited}
                        touched={touched[formFields.email.key]}
                      // disabled={id ? true : false}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className='d-flex' style={{ justifyContent: 'space-between' }}>
                      <div className='col-md-2' style={{ paddingLeft: 'initial' }}>
                        <label>Phone <span className='text-danger'>*</span></label>
                        <Input
                          // onChange={this.handleChange}
                          // onBlur={this.handleTouch}
                          value={phonenumberLenghtValidationPacket.country_code}
                          setting={formFields[formFields.countryCode.key]}
                          error={errors[formFields.countryCode.key]}
                          submited={submited}
                          touched={touched[formFields.countryCode.key]}
                          disabled={true}
                        />
                        {/* <div className='custom-test-select new'>
                        <input type='text' value={phonenumberLenghtValidationPacket.country_code} disabled={true} />
                      </div> */}



                      </div>
                      <div className='col-md-10' style={{ marginTop: '30px' }}>
                        <Input
                          onChange={this.handleChange}
                          onBlur={this.handleTouch}
                          value={form[formFields.contact.key]}
                          setting={formFields[formFields.contact.key]}
                          error={errors[formFields.contact.key]}
                          submited={submited}
                          touched={touched[formFields.contact.key]}
                        />

                      </div>

                    </div>
                  </div>


                  <div className="add-role row form-group">
                    <div className="d-flex justify-content-end">
                      {/* <button onClick={this.addUserTenantRole} className="btn btn-primary d-inline-flex">
                        <i className="mdi mdi-plus"></i> Add
                      </button> */}
                      <button
                        onClick={() => { this.addUserTenantRole() }}
                        className='text-white text-decoration-none btn btn-primary m-0'
                        style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }}
                      >
                        <i className="ti ti-plus ti-sm"></i>
                        Add
                      </button>
                    </div>
                  </div>

                  {form.roleTenantList.map((item, index) => this.renderUserTenantRoleList(item, index, rolesList, tenantList))}

                  <br />
                  <div className="form-group row">
                    <div className="col-sm-12">
                      <center>
                        <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} type="submit" onClick={(e) => this.handleSubmit(e)} className="btn btn-primary">Save</button>
                        {' '}
                        {/*  <button type="button" onClick={this.reset} className="btn btn-secondary">Reset</button>  */}
                        {' '}
                        <Link to={`/${routes.mainRoute}/${routes.containers.admin}/${routes.admin.user.name}`}><button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} type="button" className="btn btn-secondary">Cancel</button></Link>
                      </center>
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({
    rolesList: get(state, 'app.adminRolesData.responseList', []),
    tenantListAll: get(state, 'app.tenantListAll.responseList', []),
    accountListAll: get(state, 'app.accountsList.responseList', []),
    adminVariableList: get(state, 'app.adminVariableData.responseList', []),
    tenantId: get(state, 'app.preSignInState.tenantId', ''),
    userId: get(state, 'app.preSignInData.userId', ''),
    tenantType: get(state, 'app.preSignInData.responseList[0].tenantType', ''),
    authToken: get(state, 'app.signInData.authToken', ''),
  }), {
  addAdminUserAction,
  getTenantAction,
  getAdminUserListAction,
  getAccountsListAction,
  getAdminRolesListAction,
  getAdminUserSingleListAction,
  getUserListByEmailAction,
  configAttributeAction
}
)(AddUser);

AddUser.propTypes = {
  configurationList: PropTypes.array,
  tenantId: PropTypes.number,
  userId: PropTypes.number,
  authToken: PropTypes.string,
};
